import { Component, Input} from '@angular/core';
import { AnswerRatingService } from 'src/app/services/answer-rating/answer-rating.service';
import { IMessage } from 'src/app/interfaces/message.interface';

@Component({
  selector: 'app-human-assistance-request',
  templateUrl: './human-assistance-request.component.html',
  styleUrls: ['./human-assistance-request.component.scss'],
})
export class HumanAssistanceRequestComponent {
  @Input() public message!: IMessage;
  /** Custom HTML text to show instead of the default message. */
  @Input() public customText = '';
  /** Whether to show the email input field. Default: true. */
  @Input() public showEmail = true;
  public email: string = '';
  public touched = false;

  public get isEmailValid(): boolean {
    return this.arService.isEmailValid(this.email);
  }

  constructor(private arService: AnswerRatingService) {}

  public closeMessage(): void {
    this.message.showHumanAssistanceMessage = false;
  }

  public async sendEmailData() {
    if (this.isEmailValid) {
      await this.arService.requestHumandAssistance(this.email, this.message.id!);
      this.message.showHumanAssistanceMessage = false;
      this.message.humanAssistanceRequested = true;
    }
  }
}
